import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg, fmt } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CoinPicker } from "@/components/wallet/DepositCrypto";

export const WithdrawForm = ({ method, onDone }) => {
  const { user, refresh } = useAuth();
  const [cfg, setCfg] = useState(null);
  const [coin, setCoin] = useState("TRX");
  const [f, setF] = useState({ amount: "", address: "", iban: "", holder: "", bank_name: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  useEffect(() => {
    api.get("/wallet/config").then((r) => setCfg(r.data));
  }, []);

  const rate = cfg ? (coin === "USDT" ? cfg.rate_usdt : cfg.rate_trx) : 0;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const body = { method, amount_try: Number(f.amount) };
      if (method === "crypto") Object.assign(body, { coin, address: f.address });
      else Object.assign(body, { iban: f.iban, holder: f.holder, bank_name: f.bank_name });
      await api.post("/wallet/withdraw", body);
      toast.success("Çekim talebiniz alındı. Onay sonrası gönderilecek.");
      refresh();
      onDone();
    } catch (err) {
      toast.error(errMsg(err));
    }
    setLoading(false);
  };

  return (
    <form onSubmit={submit} className="space-y-5 x-rise">
      {method === "crypto" && (
        <div>
          <span className="x-label">Coin Seçin</span>
          <CoinPicker coin={coin} setCoin={setCoin} />
        </div>
      )}
      <div>
        <div className="flex justify-between">
          <span className="x-label">Çekim Tutarı (TL)</span>
          <button type="button" onClick={() => setF({ ...f, amount: String(user.balance) })} className="text-[13px] font-bold text-[var(--x-muted)] hover:text-white">
            Bakiye: ₺{fmt(user.balance)}
          </button>
        </div>
        <input data-testid="withdraw-amount-input" type="number" inputMode="decimal" className="x-input" placeholder={`Min. ${cfg?.min_withdraw ?? ""}`} value={f.amount} onChange={set("amount")} required />
        {method === "crypto" && rate > 0 && f.amount && (
          <div className="mt-2 text-[13px] text-[var(--x-muted)]">≈ <b className="text-white">{fmt(Number(f.amount) / rate, 4)} {coin}</b></div>
        )}
      </div>
      {method === "crypto" ? (
        <div>
          <span className="x-label">{coin} Cüzdan Adresi (TRC20)</span>
          <input data-testid="withdraw-address-input" className="x-input font-mono" placeholder="T..." value={f.address} onChange={set("address")} required />
        </div>
      ) : (
        <>
          <div>
            <span className="x-label">IBAN</span>
            <input data-testid="withdraw-iban-input" className="x-input font-mono" placeholder="TR00 0000 0000 0000 0000 0000 00" value={f.iban} onChange={set("iban")} required />
          </div>
          <div>
            <span className="x-label">Ad Soyad</span>
            <input data-testid="withdraw-holder-input" className="x-input" value={f.holder} onChange={set("holder")} required />
          </div>
          <div>
            <span className="x-label">Banka Adı</span>
            <input data-testid="withdraw-bank-input" className="x-input" value={f.bank_name} onChange={set("bank_name")} required />
          </div>
        </>
      )}
      <button data-testid="withdraw-submit-btn" disabled={loading} className="x-btn x-btn-primary w-full py-3.5">
        {loading && <Loader2 size={18} className="animate-spin" />} Talep Gönder
      </button>
    </form>
  );
};
